import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography, Container, Paper } from '@mui/material';
import { Home as HomeIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';

const NotFound = () => {
  const { t, i18n } = useTranslation(['common', 'navigation']);
  const navigate = useNavigate();
  const isRtl = ['dari', 'ps'].includes(i18n.language);
  
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 8,
          direction: isRtl ? 'rtl' : 'ltr',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 6,
            borderRadius: 2,
            width: '100%',
            maxWidth: 600,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography variant="h1" sx={{ fontSize: '8rem', fontWeight: 700, color: 'primary.main', lineHeight: 1 }}>
            404
          </Typography>
          
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 500 }}>
            {t('common:page_not_found')}
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
            {t('common:page_not_found_message')}
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            gap: 2, 
            flexWrap: 'wrap', 
            justifyContent: 'center',
            flexDirection: isRtl ? 'row-reverse' : 'row'
          }}>
            <Button
              variant="outlined"
              startIcon={isRtl ? null : <ArrowBackIcon />}
              endIcon={isRtl ? <ArrowBackIcon /> : null}
              onClick={() => navigate(-1)}
              sx={{
                flexDirection: isRtl ? 'row-reverse' : 'row',
                '& .MuiButton-startIcon': {
                  marginLeft: isRtl ? '8px' : '-4px',
                  marginRight: isRtl ? '-4px' : '8px'
                },
                '& .MuiButton-endIcon': {
                  marginLeft: isRtl ? '-4px' : '8px',
                  marginRight: isRtl ? '8px' : '-4px'
                }
              }}
            >
              {t('common:back')}
            </Button>
            
            <Button
              variant="contained"
              startIcon={isRtl ? null : <HomeIcon />}
              endIcon={isRtl ? <HomeIcon /> : null}
              onClick={() => navigate('/dashboard')}
              sx={{
                flexDirection: isRtl ? 'row-reverse' : 'row',
                '& .MuiButton-startIcon': {
                  marginLeft: isRtl ? '8px' : '-4px',
                  marginRight: isRtl ? '-4px' : '8px'
                },
                '& .MuiButton-endIcon': {
                  marginLeft: isRtl ? '-4px' : '8px',
                  marginRight: isRtl ? '8px' : '-4px'
                }
              }}
            >
              {t('common:go_home')}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound; 